import ReactDOM from "react-dom/client";
import App from "./App";

import { registerLicense } from "@syncfusion/ej2-base";
registerLicense(process.env.REACT_APP_SYNCFUSION_KEY as string);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
